/* eslint-disable */
/**
 * WARNING: THIS FILE IS AUTO-GENERATED, DO NOT EDIT IT DIRECTLY!
 */

import * as Types from './types'

import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import fetcher from '../../fetchers/fetcher';

export type GetAddressFromAutocompleteQueryVariables = Types.Exact<{
  input: Types.AddressAutocompleteResultInput;
}>;


export type GetAddressFromAutocompleteQuery = { __typename?: 'Query', addressFromAutocomplete?: { __typename?: 'Address', id: string, address1?: string | null, cityNameShort: string, countryNameShort: string, longitude: number, latitude: number, metroAreaNameShort?: string | null, regionNameAbbreviated: string, streetNameShort?: string | null, streetNumber?: string | null, zipCode?: string | null, unitNumber?: string | null } | null };


export const GetAddressFromAutocompleteDocument = /*#__PURE__*/ `
    query GetAddressFromAutocomplete($input: AddressAutocompleteResultInput!) {
  addressFromAutocomplete(input: $input) {
    id
    address1
    cityNameShort
    countryNameShort
    longitude
    latitude
    metroAreaNameShort
    regionNameAbbreviated
    streetNameShort
    streetNumber
    zipCode
    unitNumber
  }
}
    `;
export const useGetAddressFromAutocompleteQuery = <
      TData = GetAddressFromAutocompleteQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAddressFromAutocompleteQueryVariables,
      options?: UseQueryOptions<GetAddressFromAutocompleteQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAddressFromAutocompleteQuery, TError, TData>(
      ['GetAddressFromAutocomplete', variables],
      fetcher<GetAddressFromAutocompleteQuery, GetAddressFromAutocompleteQueryVariables>(client, GetAddressFromAutocompleteDocument, variables, headers),
      options
    );